import { findMessage } from '@bimser/components';

const errorCodeBuilders: Record<string, () => string> = {
	'STD.ERROR_000': () => findMessage.get('101454'),
	'STD.ERROR_001': () => findMessage.get('101455'),
	'STD.ERROR_002': () => findMessage.get('101456'),
	'STD.ERROR_003': () => findMessage.get('101457'),
	'STD.ERROR_004': () => findMessage.get('101458'),
	'STD.ERROR_005': () => findMessage.get('101459'),
	'STD.ERROR_006': () => findMessage.get('101460'),
	'STD.ERROR_007': () => findMessage.get('101461'),
	'STD.ERROR_008': () => findMessage.get('101462'),
	'STD.ERROR_009': () => findMessage.get('101463'),
	'STD.ERROR_010': () => findMessage.get('101464'),
	'STD.ERROR_011': () => findMessage.get('101465'),
	'STD.ERROR_012': () => findMessage.get('101466'),
	'STD.ERROR_013': () => findMessage.get('101467'),
	'STD.ERROR_014': () => findMessage.get('101468'),
	'STD.ERROR_015': () => findMessage.get('101469'),
	'STD.ERROR_016': () => findMessage.get('101470'),
	'STD.ERROR_017': () => findMessage.get('101471'),
	'STD.ERROR_018': () => findMessage.get('101472'),
	'STD.ERROR_019': () => findMessage.get('101473'),
	'STD.ERROR_020': () => findMessage.get('101474'),
	'STD.ERROR_023': () => findMessage.get('102190'),
	'STD.ERROR_025': () => findMessage.get('1010007'),
	'STD.ERROR_030': () => findMessage.get('103274'),
	'STD.ERROR_031': () => findMessage.get('103641'),
	'STD.ERROR_036': () => findMessage.get('101203'),
	'STD.ERROR_033': () => findMessage.get('101252'),
	'STD.ERROR_042': () => findMessage.get('102809'),
	'STD.ERROR_052': () => findMessage.get('103392'),
	'STD.ERROR_056': () => findMessage.get('102987'),
	'STD.ERROR_064': () => findMessage.get('101026'),
	'STD.ERROR_065': () => findMessage.get('103626'),
	STUD_SERV_0003: () => findMessage.get('103680'),
	'DSM.ERROR_000': () => findMessage.get('101454'),
	'DSM.ERROR_001': () => findMessage.get('101475'),
	'DSM.ERROR_002': () => findMessage.get('101476'),
	'DSM.ERROR_003': () => findMessage.get('101477'),
	'DSM.ERROR_005': () => findMessage.get('101478'),
	'DSM.ERROR_006': () => findMessage.get('101479'),
	'DSM.ERROR_007': () => findMessage.get('101480'),
	'DSM.ERROR_008': () => findMessage.get('101481'),
	'DSM.ERROR_009': () => findMessage.get('101482'),
	'DSM.ERROR_010': () => findMessage.get('101483'),
	'DSM.ERROR_011': () => findMessage.get('101484'),
	'DSM.ERROR_012': () => findMessage.get('101485'),
	'DSM.ERROR_013': () => findMessage.get('101486'),
	'DSM.ERROR_014': () => findMessage.get('101487'),
	'DSM.ERROR_015': () => findMessage.get('101488'),
	'DSM.ERROR_016': () => findMessage.get('101489'),
	'DSM.ERROR_017': () => findMessage.get('101490'),
	'DSM.ERROR_018': () => findMessage.get('101491'),
	'DSM.ERROR_019': () => findMessage.get('101492'),
	'DSM.ERROR_020': () => findMessage.get('101493'),
	'DSM.ERROR_021': () => findMessage.get('101494'),
	'DSM.ERROR_022': () => findMessage.get('101495'),
	'DSM.ERROR_023': () => findMessage.get('101496'),
	'DSM.ERROR_024': () => findMessage.get('101497'),
	'DSM.ERROR_025': () => findMessage.get('101498'),
	'DSM.ERROR_026': () => findMessage.get('101499'),
	DS_001: () => findMessage.get('101659'),
	DS_002: () => findMessage.get('101660'),
	DSP_001: () => findMessage.get('101661'),
	DSP_002: () => findMessage.get('101662'),
	DSP_003: () => findMessage.get('101663'),
	DSP_004: () => findMessage.get('101663'),
	DSP_005: () => findMessage.get('101664'),
	DSP_006: () => findMessage.get('101665'),
	DSP_007: () => findMessage.get('101666'),
	DSP_008: () => findMessage.get('101667'),
	DSP_009: () => findMessage.get('101668'),
	DSP_010: () => findMessage.get('101669'),
	DSP_011: () => findMessage.get('101670'),
	DSP_012: () => findMessage.get('101668'),
	DSP_013: () => findMessage.get('101671'),
	DSP_014: () => findMessage.get('101672'),
	DSP_015: () => findMessage.get('101673'),
	DSP_016: () => findMessage.get('101674'),
	DSP_017: () => findMessage.get('101675'),
	DSP_018: () => findMessage.get('101676'),
	DSP_019: () => findMessage.get('101475'),
	DSP_020: () => findMessage.get('101678'),
	'FRM.025': () => findMessage.get('102225'),
	'FRM.026': () => findMessage.get('102226'),
	'FRM.034': () => findMessage.get('100628'),
	'FRM.035': () => findMessage.get('100628'),
	'FRM.039': () => findMessage.get('100628'),
	'FRM.040': () => findMessage.get('100629'),
	'FRM.041': () => findMessage.get('100669'),
	'FRM.042': () => findMessage.get('100678'),
	'FRM.043': () => findMessage.get('101945'),
	'FRM.044': () => findMessage.get('1010017'),
	'FRM.045': () => findMessage.get('1010018'),
	'FRM.074': () => findMessage.get('103031'),

	HRES_SERV_0001: () => findMessage.get('102405'),
	HRES_SERV_0002: () => findMessage.get('101925').replace('{0}', findMessage.get('101928')),
	HRES_SERV_0003: () => findMessage.get('101927').replace('{0}', findMessage.get('101928')),
	HRES_SERV_0004: () => findMessage.get('101925').replace('{0}', findMessage.get('101929')),
	HRES_SERV_0005: () => findMessage.get('101927').replace('{0}', findMessage.get('101929')),
	HRES_SERV_0006: () => findMessage.get('102044'),
	HRES_SERV_0007: () =>
		findMessage.get('101925').replace('{0}', findMessage.get('100465').toLocaleLowerCase()),
	HRES_SERV_0008: () =>
		findMessage.get('101927').replace('{0}', findMessage.get('100465').toLocaleLowerCase()),
	HRES_SERV_0009: () =>
		findMessage.get('101925').replace('{0}', findMessage.get('100722').toLocaleLowerCase()),
	HRES_SERV_0010: () =>
		findMessage.get('102406').replace('{0}', findMessage.get('100276').toLocaleLowerCase()),
	HRES_SERV_0011: () =>
		findMessage.get('102407').replace('{0}', findMessage.get('100722').toLocaleLowerCase()),
	HRES_SERV_0012: () =>
		findMessage.get('101927').replace('{0}', findMessage.get('100722').toLocaleLowerCase()),
	HRES_SERV_0013: () =>
		findMessage.get('102408').replace('{0}', findMessage.get('100276').toLocaleLowerCase()),
	HRES_SERV_00015: () => findMessage.get('102381'),
	HRES_SERV_00016: () => findMessage.get('102399'),
	HRES_SERV_00017: () => findMessage.get('102790'),
	HRES_SERV_00018: () => findMessage.get('102791'),
	HRES_SERV_00019: () => findMessage.get('102790'),
	HRES_SERV_00034: () => findMessage.get('102792'),
	HRES_SERV_0020: () => findMessage.get('102793'),
	HRES_SERV_00021: () => findMessage.get('102794'),
	HRES_SERV_00022: () => findMessage.get('102793'),
	HRES_SERV_0023: () => findMessage.get('103047'),
	HRES_SERV_0029: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102595')).replace('{1}', '50'),
	HRES_SERV_0030: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102596')).replace('{1}', '250'),
	HRES_SERV_0031: () => findMessage.get('102594').replace('{0}', findMessage.get('102595')),
	HRES_SERV_0032: () => findMessage.get('102594').replace('{0}', findMessage.get('102596')),
	HRES_SERV_0034: () => findMessage.get('102642'),
	HRES_SERV_0035: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102667')).replace('{1}', '50'),
	HRES_SERV_0036: () => findMessage.get('102594').replace('{0}', findMessage.get('102667')),
	HRES_SERV_0037: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102668')).replace('{1}', '200'),
	HRES_SERV_0038: () => findMessage.get('102594').replace('{0}', findMessage.get('102668')),
	HRES_SERV_0039: () => findMessage.get('102669'),
	HRES_SERV_0040: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('100729')).replace('{1}', '50'),
	HRES_SERV_0041: () => findMessage.get('102670'),
	HRES_SERV_0042: () => findMessage.get('102671'),
	HRES_SERV_0043: () => findMessage.get('102686').replace('{0}', findMessage.get('101375')),
	HRES_SERV_0044: () => findMessage.get('102686').replace('{0}', findMessage.get('101374')),
	HRES_SERV_0045: () => findMessage.get('102686').replace('{0}', findMessage.get('100728')),
	HRES_SERV_0046: () => findMessage.get('102686').replace('{0}', findMessage.get('100736')),
	HRES_SERV_0047: () => findMessage.get('102686').replace('{0}', findMessage.get('100735')),
	HRES_SERV_0048: () => findMessage.get('102686').replace('{0}', findMessage.get('100970')),
	HRES_SERV_0049: () => findMessage.get('102686').replace('{0}', findMessage.get('100973')),
	HRES_SERV_0050: () => findMessage.get('102686').replace('{0}', findMessage.get('102476')),
	HRES_SERV_0051: () => findMessage.get('102686').replace('{0}', findMessage.get('102592')),
	HRES_SERV_0052: () => findMessage.get('102686').replace('{0}', findMessage.get('101327')),
	HRES_SERV_0053: () => findMessage.get('102686').replace('{0}', findMessage.get('101421')),
	HRES_SERV_0054: () => findMessage.get('102686').replace('{0}', findMessage.get('101328')),
	HRES_SERV_0055: () => findMessage.get('102686').replace('{0}', findMessage.get('102631')),
	HRES_SERV_0057: () => findMessage.get('102691'),
	HRES_SERV_0058: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('100722')).replace('{1}', '40'),
	HRES_SERV_0059: () => findMessage.get('102594').replace('{0}', findMessage.get('100722')),
	HRES_SERV_0060: () => findMessage.get('102740').replace('{0}', findMessage.get('100722')),
	HRES_SERV_0061: () => findMessage.get('102594').replace('{0}', findMessage.get('100131')),
	HRES_SERV_0062: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('100131')).replace('{1}', '40'),
	HRES_SERV_0063: () => findMessage.get('102594').replace('{0}', findMessage.get('100132')),
	HRES_SERV_0064: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('100132')).replace('{1}', '40'),
	HRES_SERV_0065: () => findMessage.get('102594').replace('{0}', findMessage.get('100627')),
	HRES_SERV_0066: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('100627')).replace('{1}', '200'),
	HRES_SERV_0067: () => findMessage.get('102594').replace('{0}', findMessage.get('100509')),
	HRES_SERV_0068: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('100509')).replace('{1}', '200'),
	HRES_SERV_0070: () => findMessage.get('102740').replace('{0}', findMessage.get('100727')),
	HRES_SERV_0069: () => findMessage.get('102740').replace('{0}', findMessage.get('100724')),
	HRES_SERV_0071: () => findMessage.get('102594').replace('{0}', findMessage.get('100472')),
	HRES_SERV_0072: () => findMessage.get('102594').replace('{0}', findMessage.get('100474')),
	HRES_SERV_0073: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102497')).replace('{1}', '250'),
	HRES_SERV_0074: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102498')).replace('{1}', '250'),
	HRES_SERV_0075: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102504')).replace('{1}', '250'),
	HRES_SERV_0076: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102495')).replace('{1}', '250'),
	HRES_SERV_0077: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102493')).replace('{1}', '250'),
	HRES_SERV_0078: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102494')).replace('{1}', '250'),
	HRES_SERV_0079: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102480')).replace('{1}', '250'),
	HRES_SERV_0080: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102501')).replace('{1}', '250'),
	HRES_SERV_0081: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102499')).replace('{1}', '250'),
	HRES_SERV_0082: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102500')).replace('{1}', '250'),
	HRES_SERV_0083: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102502')).replace('{1}', '250'),
	HRES_SERV_0084: () =>
		findMessage.get('102593').replace('{0}', findMessage.get('102496')).replace('{1}', '250'),
	HRES_SERV_0085: () => findMessage.get('102740').replace('{0}', findMessage.get('102476')),
	HRES_SERV_0093: () => findMessage.get('102740').replace('{0}', findMessage.get('102763')),
	HRES_SERV_0094: () => findMessage.get('102801'),
	HRES_SERV_0095: () => findMessage.get('103129'),
	HRES_SERV_0109: () => findMessage.get('103247'),
	HRES_SERV_0111: () => findMessage.get('103258'),
	FRMW_CORE_0004: () => findMessage.get('102739'),
	FRMW_CORE_0043: () => findMessage.get('103393'),

	DMS__OBJ__0006: () => findMessage.get('101699').replace('{0}', findMessage.get('101688')),
	DMS__OBJ__0010: () => findMessage.get('102455'),
	'FRM.067': () => findMessage.get('102549'),
	'WF.FLOW_PERMISSION': () => findMessage.get('102550'),
	'WF.INACTIVE_ASSIGNMENT_EXCEPTION': () => findMessage.get('103122'),
	'WF.STARTER_NOT_FOUND': () =>
		findMessage.get('103176').replace('{0}', findMessage.get('1010002')),
	'WF.POSITION_NOT_FOUND': () =>
		findMessage.get('103176').replace('{0}', findMessage.get('100202')),
	'WF.GROUP_NOT_FOUND': () =>
		findMessage.get('103176').replace('{0}', findMessage.get('1010019')),
	'WF.PAUSER_NOT_FOUND': () =>
		findMessage.get('103176').replace('{0}', findMessage.get('1010039')),
	'WF.NOTIFICATION_NOT_FOUND': () =>
		findMessage.get('103176').replace('{0}', findMessage.get('100713')),
	'WF.END_NOT_FOUND': () => findMessage.get('103176').replace('{0}', findMessage.get('1010003')),
	'WF.STATEINFO_NOT_FOUND': () =>
		findMessage.get('103176').replace('{0}', findMessage.get('1010009')),
	DMS__API__0001: () => findMessage.get('102552'),
	DMS__API__0002: () => findMessage.get('102553'),
	DMS__SERV_0001: () => findMessage.get('102552'),
	DMS__CORE_0000: () => findMessage.get('102554'),
	DMS__FILE_0001: () => findMessage.get('102556'),
	DMS__FILE_0002: () => findMessage.get('102557'),
	DMS__FILE_0003: () => findMessage.get('102558'),
	DMS__FILE_0004: () => findMessage.get('102559'),
	DMS__FILE_0005: () => findMessage.get('102556'),
	DMS__FILE_0006: () => findMessage.get('102557'),
	DMS__FILE_0007: () => findMessage.get('102558'),
	DMS__FILE_0008: () => findMessage.get('102559'),
	DMS__FILE_0069: () => findMessage.get('102707'),
	DMS__FILE_0070: () => findMessage.get('102706'),
	DMS__FILE_0074: () => findMessage.get('103232'),
	DMS__FILE_0075: () => findMessage.get('103233'),
	DMS__FILE_0076: () => findMessage.get('103224'),
	DMS__FILE_0077: () => findMessage.get('103677'),
	DMS__EXPL_0001: () => findMessage.get('102553'),
	DMS__EXPL_0002: () => findMessage.get('102553'),
	DMS__EXPL_0003: () => findMessage.get('102560'),
	DMS__EXPL_0004: () => findMessage.get('102560'),
	DMS__EXPL_0005: () => findMessage.get('102561'),
	DMS__EXPL_0006: () => findMessage.get('102561'),
	DMS__EXPL_0007: () => findMessage.get('102562'),
	DMS__EXPL_0008: () => findMessage.get('102563'),
	DMS__EXPL_0009: () => findMessage.get('102564'),
	DMS__EXPL_0010: () => findMessage.get('102565'),
	DMS__EXPL_0011: () => findMessage.get('102566'),
	DMS__EXPL_0012: () => findMessage.get('102567'),
	DMS__EXPL_0013: () => findMessage.get('102568'),
	DMS__EXPL_0014: () => findMessage.get('102569'),
	DMS__EXPL_0020: () => findMessage.get('103208'),
	DMS__EXPL_0021: () => findMessage.get('103208'),
	DMS__FOLD_0001: () => findMessage.get('102570'),
	DMS__FOLD_0002: () => findMessage.get('102571'),
	DMS__FOLD_0003: () => findMessage.get('102558'),
	DMS__FOLD_0004: () => findMessage.get('102559'),
	DMS__FOLD_0005: () => findMessage.get('102572'),
	DMS__FOLD_0033: () => findMessage.get('103225'),
	DMS__FOLD_0034: () => findMessage.get('103226'),
	DMS__FOLD_0035: () => findMessage.get('103227'),
	DMS__OBJ__0001: () => findMessage.get('102570'),
	DMS__OBJ__0002: () => findMessage.get('102573'),
	DMS__OBJ__0003: () => findMessage.get('102573'),
	DMS__OBJ__0004: () => findMessage.get('102562'),
	DMS__OBJ__0005: () => findMessage.get('102574'),
	DMS__SCUT_0001: () => findMessage.get('102559'),
	DMS__SCUT_0003: () => findMessage.get('102744'),
	DMS__CONT_0001: () => findMessage.get('102562'),
	DMS__CONT_0002: () => findMessage.get('102575'),
	DMS__CONT_0003: () => findMessage.get('102576'),
	OOSW_WAPI_0001: () => findMessage.get('102552'),
	OOSW_WAPI_0002: () => findMessage.get('102553'),
	DMS__OBJ__0007: () => findMessage.get('102553'),
	DMS__OBJ__0008: () => findMessage.get('102577'),
	DMS__OBJ__0009: () => findMessage.get('102578'),
	DMS__OBJ__0011: () => findMessage.get('102579'),
	DMS__OBJ__0012: () => findMessage.get('102580'),
	DMS__OBJ__0013: () => findMessage.get('102581'),
	DMS__OBJ__0014: () => findMessage.get('102582'),
	DMS__OBJ__0015: () => findMessage.get('102582'),
	DMS__OBJ__0213: () => findMessage.get('102745'),
	DMS__OBJ__0214: () => findMessage.get('102746'),
	DMS__OBJ__0067: () => findMessage.get('101183'),
	DMS__OBJ__0216: () => findMessage.get('103228'),
	DMS__OBJ__0217: () => findMessage.get('103229'),
	DMS__EXPL_0077: () => findMessage.get('102760'),
	DMS__EXPL_0078: () => findMessage.get('102875'),
	DMS__EXPL_0079: () => findMessage.get('103304'),
	DMS__CONT_0163: () => findMessage.get('103230'),
	DMS__CONT_0164: () => findMessage.get('103231'),

	AUTH_SERV_0004: () => findMessage.get('102588'),
	AUTH_SERV_0005: () => findMessage.get('102585'),
	AUTH_SERV_0006: () => findMessage.get('102586'),
	AUTH_SERV_0007: () => findMessage.get('102587'),
	AUTH_SERV_0008: () => findMessage.get('102553'),
	AUTH_SERV_0022: () => findMessage.get('103270'),
	AUTH_SERV_0041: () => findMessage.get('102701'),
	AUTH_SERV_0043: () => findMessage.get('103027'),
	AUTH_SERV_0082: () => findMessage.get('102619'),
	AUTH_SERV_0083: () => findMessage.get('102620'),
	AUTH_SERV_0084: () => findMessage.get('102621'),
	AUTH_SERV_0085: () => findMessage.get('102622'),
	AUTH_SERV_0086: () => findMessage.get('102620'),
	AUTH_SERV_0087: () => findMessage.get('102621'),
	AUTH_SERV_0088: () => findMessage.get('102622'),
	AUTH_SERV_0089: () => findMessage.get('102623'),
	AUTH_SERV_0090: () => findMessage.get('102624'),
	AUTH_SERV_0091: () => findMessage.get('102621'),
	AUTH_SERV_0092: () => findMessage.get('102626'),
	AUTH_SERV_0099: () => findMessage.get('102645'),
	AUTH_SERV_0101: () => findMessage.get('102690'),
	WEBI_SERV_0106: () => findMessage.get('103014'),
	WEBI_SERV_0107: () => findMessage.get('102906'),
	WEBI_SERV_0108: () => findMessage.get('102907'),
	WEBI_SERV_0109: () => findMessage.get('102908'),
	WEBI_SERV_0110: () => findMessage.get('102909'),
	WEBI_SERV_0111: () => findMessage.get('102910'),
	WEBI_SERV_0112: () => findMessage.get('102911'),
	WEBI_SERV_0036: () => findMessage.get('102714'),
	WEBI_SERV_0129: () => findMessage.get('103209'),
	WEBI_SERV_0018: () => findMessage.get('102843'),
	WEBI_SERV_0017: () => findMessage.get('102844'),
	WEBI_SERV_0019: () => findMessage.get('102845'),
	WEBI_SERV_0130: () => findMessage.get('103221'),
	WEBI_SERV_0131: () => findMessage.get('103221'),
	WEBI_SERV_0133: () => findMessage.get('100065'),
	WEBI_SERV_0134: () => findMessage.get('100066'),
	WEBI_SERV_0135: () => findMessage.get('100067'),
	WEBI_SERV_0136: () => findMessage.get('100068'),
	WEBI_SERV_0137: () => findMessage.get('100069'),
	WEBI_SERV_0138: () => findMessage.get('100070'),
	WEBI_SERV_0139: () => findMessage.get('100071'),
	WEBI_SERV_0140: () => findMessage.get('100072'),
	WEBI_SERV_0141: () => findMessage.get('100073'),
	WEBI_SERV_0142: () => findMessage.get('100074'),
	WEBI_SERV_0143: () => findMessage.get('100076'),
	WEBI_SERV_0144: () => findMessage.get('100077'),
	AUTZ_SERV_0013: () => findMessage.get('102761'),
	AUTZ_SERV_0105: () => findMessage.get('103246'),
	AUTZ_SERV_0106: () => findMessage.get('103234'),
	AUTZ_SERV_0057: () => findMessage.get('103223'),
	AUTZ_SERV_0062: () => findMessage.get('102762'),
	DMS__BASE_0024: () => findMessage.get('102769'),
	DMS__BASE_0010: () =>
		findMessage.get('101398').replace('{0}', findMessage.get('100855').toLocaleLowerCase()),
	DMS__BASE_0017: () => findMessage.get('102079'),
	'CAPTURE.FASTSCAN.SCANNER_NOT_FOUND': () => findMessage.get('103162'),
	'CAPTURE.FASTSCAN.SCANNER_NOT_AVAILABLE': () => findMessage.get('103163'),
	'CAPTURE.ABBYY_SERVICE.NOT_AVAILABLE': () => findMessage.get('103239'),
	DSIG_SERV_0001: () => findMessage.get('103271'),
	DSIG_SERV_0002: () => findMessage.get('103220'),
	DSIG_SERV_0003: () => findMessage.get('103728'),
	'WF.PROCESS_REQUEST_NOT_FOUND': () => findMessage.get('103646'),
	UNIQ_SERV_0004: () => findMessage.get('101275'),
	CORE_SERV_0002: () => findMessage.get('103707')
};

const ErrorCodes = new Proxy(
	{},
	{
		get(_, prop: string) {
			const builder = errorCodeBuilders[prop];
			if (typeof builder === 'function') {
				return builder();
			}
			return undefined;
		}
	}
);

export { ErrorCodes };
